/**
 * `/pulpit` — the dashboard's address from 15 September 2026 until it became the app's home at `/`
 * on 23 September. Kept as a redirect so a trainer's bookmark or an old link still lands on it.
 *
 * `replace: true`, so the old address leaves no history entry behind: Back from the dashboard goes
 * wherever the trainer was before, not to `/pulpit`, which would bounce them forward again.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_shell/pulpit')({
  beforeLoad: () => {
    // `throw: true` makes `redirect` raise the router's own Response itself; see `_shell.tsx`.
    redirect({ to: '/', replace: true, throw: true });
  },
});
